import {dateEnUS, dateNlNL, dateDeDE, dateFrFR, enUS, nlNL, deDE, frFR} from "naive-ui";

export enum Language {
    nlNL = 0,
    enUS = 1,
    deDE = 2,
    frFR = 3
}

export const LanguageOptions = [
    {label: "core.languages.dutch", value: Language.nlNL},
    {label: "core.languages.english", value: Language.enUS},
    {label: "core.languages.german", value: Language.deDE},
    {label: "core.languages.french", value: Language.frFR},
];

export const navigatorToEnum = (name: string) => {
    switch (name) {
        case "nl-NL":
            return Language.nlNL;
        case "en-US":
            return Language.enUS;
        case "de-DE":
            return Language.deDE;
        case "fr-FR":
            return Language.frFR;
        default:
            return Language.enUS;
    }
}

export const enumToNavigator = (language: Language) => {
    switch (language) {
        case Language.nlNL:
            return "nl-NL";
        case Language.enUS: 
            return "en-US";
        case Language.deDE:
            return "de-DE";
        case Language.frFR:
            return "fr-FR";
        default:
            return "en-US";
    }
}

export const languageToNaiveLocale = (lang: Language) => {
    switch (lang) {
        case Language.nlNL:
            return {
                locale: nlNL,
                dateLocale: dateNlNL
            };
        case Language.enUS:
            return {
                locale: enUS,
                dateLocale: dateEnUS
            };
        case Language.deDE:
            return {
                locale: deDE,
                dateLocale: dateDeDE
            };
        case Language.frFR:
            return {
                locale: frFR,
                dateLocale: dateFrFR
            };
    }
}

export const countryToLanguageMap: Record<string, Language> = {
    0: Language.nlNL,
    1: Language.nlNL,
    2: Language.frFR,
    3: Language.deDE,
    4: Language.frFR,
};

export function getLanguageFromCountry(countryCode: number): Language {
    return countryToLanguageMap[countryCode] ?? Language.enUS;
}
